export default __webpack_public_path__ + "static/media/apply.6a87e232.svg";